import React, { useCallback, useState } from 'react'
import resendVerificationEmail from '../../../../../helpers/resendVerificationEmail'
import {
  VerificationContainer,
  VerificationIconWrapper,
  VerificationBody,
  Divider,
  ResendRow,
  ResendLink,
  HintText,
} from './LoyaltySignInModal.css'

const MailIcon = () => (
  <svg width="91" height="52" viewBox="0 0 91 52" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M90.5239 48.2657C90.5239 50.3026 88.8552 52 86.7582 52H22.0119C19.9578 52 18.2461 50.3026 18.2461 48.2657V9.73427C18.2461 7.69736 19.915 6 22.0119 6H86.8009C88.8552 6 90.5666 7.65496 90.5666 9.73427V48.2657H90.5239Z"
      fill="#08375A"
    />
    <path
      d="M54.4027 38.7641C53.119 38.7641 51.8779 38.3398 50.9365 37.5335L22.8213 13.3028C22.0511 12.6663 22.0082 11.5206 22.6501 10.7992C22.9925 10.4172 23.506 10.2051 24.0195 10.2051C24.4475 10.2051 24.8754 10.3748 25.2177 10.6294L53.3329 34.8601C53.5897 35.1147 54.0176 35.2419 54.4027 35.2419C54.8307 35.2419 55.2158 35.1147 55.4725 34.8601L83.5878 10.6294C83.9299 10.3324 84.3582 10.2051 84.7856 10.2051C85.2991 10.2051 85.8127 10.4172 86.1557 10.7992C86.4551 11.1386 86.6257 11.6055 86.5831 12.1147C86.5404 12.5814 86.3263 13.0058 85.9842 13.3453L57.869 37.491C56.9275 38.2973 55.6866 38.7641 54.4027 38.7641Z"
      fill="#59C369"
    />
    <path
      d="M24.0211 10.4149C24.3635 10.4149 24.7058 10.5422 25.0054 10.7544L53.1205 34.985C53.4629 35.282 53.9336 35.4518 54.4044 35.4518C54.9179 35.4518 55.3458 35.282 55.6882 34.985L83.8032 10.7544C84.06 10.5422 84.4021 10.3724 84.7877 10.3724C85.2159 10.3724 85.6433 10.5422 85.9001 10.8817C86.1569 11.1787 86.2857 11.5607 86.2422 11.9426C86.1996 12.3244 86.0289 12.7064 85.7286 12.961L57.6139 37.1916C56.758 37.9555 55.6026 38.3798 54.3616 38.3798C53.1206 38.3798 52.008 37.9555 51.1093 37.1916L22.9942 12.961C22.395 12.4093 22.3094 11.5182 22.8658 10.8817C23.1653 10.6271 23.5932 10.4149 24.0211 10.4149ZM24.0211 9.77832C23.4221 9.77832 22.8229 10.033 22.395 10.4997C21.6247 11.3909 21.7103 12.7064 22.609 13.4703L50.7241 37.7009C51.7512 38.592 53.0778 39.0164 54.4044 39.0164C55.731 39.0164 57.0576 38.592 58.0846 37.7009L86.1996 13.4703C87.0988 12.7064 87.1841 11.3909 86.4137 10.4997C85.9854 10.033 85.3866 9.77832 84.8303 9.77832C84.3167 9.77832 83.8458 9.94809 83.4184 10.2875L55.3031 34.5182C55.0891 34.7304 54.7467 34.8153 54.4044 34.8153C54.062 34.8153 53.7625 34.7304 53.5485 34.5182L25.4333 10.2875C25.0054 9.94809 24.4919 9.77832 24.0211 9.77832Z"
      fill="#59C369"
    />
  </svg>
)

type EmailVerificationProps = {
  email: string
  onClose: () => void
}

const EmailVerification: React.FC<EmailVerificationProps> = ({ email }) => {
  const [resending, setResending] = useState(false)

  const handleResend = useCallback(async () => {
    if (resending) return
    setResending(true)
    try {
      await resendVerificationEmail(email)
    } catch {
      // silently ignore — no error surfaced per design
    } finally {
      setResending(false)
    }
  }, [email, resending])

  return (
    <VerificationContainer>
      <VerificationIconWrapper>
        <MailIcon />
      </VerificationIconWrapper>

      <VerificationBody>
        To complete your signup, click the link we sent to{' '}
        <strong>{email}</strong>.
      </VerificationBody>

      <Divider />

      <ResendRow>
        Don&apos;t see the link?{' '}
        <ResendLink type="button" onClick={handleResend} disabled={resending}>
          {resending ? 'Sending…' : 'Resend Verification'}
        </ResendLink>
      </ResendRow>

      <HintText>
        <em>Hint:</em> If you don&apos;t see it, check your spam folder.
      </HintText>
    </VerificationContainer>
  )
}

export default EmailVerification
